import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addAirliner } from '../../../store/slices/adminSlice';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const AddAirliner = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    status: 'Active',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' }); // clear error on typing
  };

  const validate = () => {
    let newErrors = {};

    if (!form.first_name) newErrors.first_name = 'First name is required';
    if (!form.last_name) newErrors.last_name = 'Last name is required';
    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = 'Invalid email format';
    }

    return newErrors;
  };

  const handleSubmit = async () => {
    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error('Please fix the errors');
      return;
    }

    setLoading(true);
    try {
      await dispatch(addAirliner(form)).unwrap();
      toast.success('Airliner created successfully and invitation email sent');
      navigate('/admin/users');
    } catch (error) {
      toast.error(error || 'Failed to create airliner');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="bg-white rounded shadow-sm p-6">

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-semibold">Add Airliner</h1>

          <button onClick={() => navigate(-1)} className="bg-yellow-400 px-4 py-2 rounded flex items-center gap-2">
            <i className="fas fa-arrow-left"></i>
            Back
          </button>
        </div>

        {/* Form Grid */}
        <div className="grid grid-cols-2 gap-6">

          {/* First Name */}
          <div>
            <label className="flex items-center gap-1 text-sm font-medium mb-1">
              First Name <span className="text-red-500">*</span>
              <span className="relative group cursor-pointer">
                <i className="fas fa-info-circle text-gray-400 text-xs"></i>
                <span className="absolute hidden group-hover:block bg-black text-white text-xs rounded px-2 py-1 top-5 left-0 whitespace-nowrap z-10">
                  Enter first name
                </span>
              </span>
            </label>

            <input
              name="first_name"
              placeholder="FIRST NAME"
              value={form.first_name}
              onChange={handleChange}
              className={`border p-2 w-full rounded ${errors.first_name ? 'border-red-500' : ''
                }`}
            />
            {errors.first_name && (
              <p className="text-red-500 text-xs mt-1">{errors.first_name}</p>
            )}
          </div>

          {/* Last Name */}
          <div>
            <label className="flex items-center gap-1 text-sm font-medium mb-1">
              Last Name <span className="text-red-500">*</span>
            </label>

            <input
              name="last_name"
              placeholder="LAST NAME"
              value={form.last_name}
              onChange={handleChange}
              className={`border p-2 w-full rounded ${errors.last_name ? 'border-red-500' : ''
                }`}
            />
            {errors.last_name && (
              <p className="text-red-500 text-xs mt-1">{errors.last_name}</p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="flex items-center gap-1 text-sm font-medium mb-1">
              Email <span className="text-red-500">*</span>
              <span className="relative group cursor-pointer">
                <i className="fas fa-info-circle text-gray-400 text-xs"></i>
                <span className="absolute hidden group-hover:block bg-black text-white text-xs rounded px-2 py-1 top-5 left-0 whitespace-nowrap z-10">
                  Enter corporate email
                </span>
              </span>
            </label>

            <input
              name="email"
              placeholder="EMAIL"
              value={form.email}
              onChange={handleChange}
              className={`border p-2 w-full rounded ${errors.email ? 'border-red-500' : ''
                }`}
            />
            {errors.email && (
              <p className="text-red-500 text-xs mt-1">{errors.email}</p>
            )}
          </div>

          {/* Status */}
          <div>
            <label className="flex items-center gap-1 text-sm font-medium mb-1">
              Status <span className="text-red-500">*</span>
              <span className="relative group cursor-pointer">
                <i className="fas fa-info-circle text-gray-400 text-xs"></i>
                <span className="absolute hidden group-hover:block bg-black text-white text-xs rounded px-2 py-1 top-5 left-0 whitespace-nowrap z-10">
                  Select user status
                </span>
              </span>
            </label>

            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="border p-2 w-full rounded"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-8">
          <button onClick={() => navigate(-1)} className="px-4 py-2 border rounded">Cancel</button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-yellow-400 px-6 py-2 rounded font-medium disabled:opacity-50"
          >
            {loading ? 'Creating...' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAirliner;